






import { Component, Prop, Vue } from 'vue-property-decorator';
import { px2Rem } from '../../../common/util';

/**
 * 格式化金额
 * @param val 金额
 * @param bit 小数点
 */
function formatAmount(val = '0', bit = 2) {
  const pattern = /^[+|-]?[0-9]+$/;
  if (pattern.test(val)) {
    return (parseFloat(val) / 100).toFixed(bit);
  }
  return (parseFloat('0') / 100).toFixed(bit);
}

/**
 * 默认金额展示字体大小
 */
const AMOUNT_FONT_SIZE = 92;
/**
 * 币种的默认展示大小样式
 */
const CURRENCY_DEF_STYLE = {
  'font-size': 44,
  'line-height': 52,
  'margin-top': 10,
};

/**
 * 金额的默认展示大小样式
 */
const AMOUNT_DEF_STYLE = {
  'font-size': 92,
  'line-height': 102,
};

/**
 * 带单位的金额展示
 * 1、金额单位小字体在金额左上侧展示
 * 2、通过size可以设置金额整体大小，字体和单位整体缩放，size为视觉稿设置的font-size，一般是2倍大小
 */
@Component
export default class AmountBox extends Vue {
  /**
   * 金额（分）
   */
  @Prop({ default: 0 }) public value!: number;

  /**
   * 金额展示小数点，默认为 2
   */
  @Prop({ default: 2 }) public bit!: number;

  /**
   * 币种
   */
  @Prop({ default: 'HK$' }) public currencyCode!: string;

  /**
   * 金额字体大小，视觉稿件提供的金额font-size
   */
  @Prop({ default: AMOUNT_FONT_SIZE }) public size!: number;

  /**
   * 金额转换为元后的字符串
   */
  public get amountYuan() {
    return formatAmount(`${this.value || 0}`, this.bit);
  }

  /**
   * 字体缩放比例
   */
  public get scaleSize() {
    return this.size / AMOUNT_FONT_SIZE;
  }

  /**
   * 币种样式
   */
  public get currencyStyle() {
    return this.parseStyles(CURRENCY_DEF_STYLE);
  }

  /**
   * 金额样式
   */
  public get amountStyle() {
    return this.parseStyles(AMOUNT_DEF_STYLE);
  }

  /**
   * 计算样式转换为rem后的样式属性对象
   * @param styles 样式值
   */
  public parseStyles(styles: { [key: string]: number }) {
    const { scaleSize } = this;
    return Object.fromEntries(Object.keys(styles).map(key => [key, px2Rem(styles[key] * scaleSize)]));
  }
}
